import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';

declare module 'axios' {
  interface AxiosResponse {
    code?: number;
  }
}

export interface IHttpRequest {
  baseUrl: string;
  timeout?: number;
}

// 默认过期时间
export const DEFAULT_TIMEOUT = 10000;

class HttpRequest {
  private instance: AxiosInstance;
  constructor(params: IHttpRequest) {
    this.instance = axios.create({
      baseURL: params.baseUrl,
      timeout: params.timeout || DEFAULT_TIMEOUT,
    });
    this.interceptors(this.instance);
  }

  public request(params: AxiosRequestConfig) {
    return this.instance(params);
  }

  private interceptors(instance: AxiosInstance) {
    // 请求拦截
    instance.interceptors.request.use(
      config => config,
      () => Promise.resolve(null),
    );

    // 响应拦截
    instance.interceptors.response.use(
      (res) => {
        const { data } = res;
        return data;
      },
      () => Promise.resolve(null),
    );
  }
}

export default HttpRequest;
